import { useEffect, useState } from 'react';
import { Button, Modal } from 'antd';
import { CheckCircleOutlined, ReloadOutlined } from '@ant-design/icons';

const UpdateNotifier = () => {
    const [updateAvailable, setUpdateAvailable] = useState(false);
    const [registration, setRegistration] = useState(null);

    useEffect(() => {
        // Service worker exists only in production builds (CRA workbox).
        // In dev the URL returns index.html → SecurityError (MIME text/html).
        if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) {
            return undefined;
        }

        let cancelled = false;

        const onControllerChange = () => {
            window.location.reload();
        };

        navigator.serviceWorker.addEventListener('controllerchange', onControllerChange);

        navigator.serviceWorker.ready
            .then((reg) => {
                if (cancelled) return;

                const trackInstalling = (worker) => {
                    if (!worker) return;
                    worker.addEventListener('statechange', () => {
                        if (
                            worker.state === 'installed' &&
                            navigator.serviceWorker.controller
                        ) {
                            setUpdateAvailable(true);
                            setRegistration(reg);
                        }
                    });
                };

                if (reg.waiting) {
                    setUpdateAvailable(true);
                    setRegistration(reg);
                }

                if (reg.installing) {
                    trackInstalling(reg.installing);
                }

                reg.addEventListener('updatefound', () => {
                    trackInstalling(reg.installing);
                });
            })
            .catch(() => {
                // No active SW yet — registration is handled by serviceWorkerRegistration.js
            });

        return () => {
            cancelled = true;
            navigator.serviceWorker.removeEventListener('controllerchange', onControllerChange);
        };
    }, []);

    const handleUpdate = () => {
        if (registration && registration.waiting) {
            registration.waiting.postMessage({ type: 'SKIP_WAITING' });
        }
        setUpdateAvailable(false);
    };

    return (
        <Modal
            open={updateAvailable}
            title="Доступно обновление!"
            footer={[
                <Button key="later" onClick={() => setUpdateAvailable(false)}>
                    Позже
                </Button>,
                <Button
                    key="update"
                    type="primary"
                    icon={<ReloadOutlined />}
                    onClick={handleUpdate}
                >
                    Обновить сейчас
                </Button>,
            ]}
        >
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <CheckCircleOutlined style={{ color: '#52c41a' }} />
                <span>Доступна новая версия приложения. Обновите для получения последних улучшений.</span>
            </div>
        </Modal>
    );
};

export default UpdateNotifier;
